<template>
  <div class="conmter">
    <div class="scroll">
    <li
      class="fontSize"
      :active="active"
      v-for="item in ItemData"
      :key="item.id"
      
      :class="[active == item.id  ? 'listclick' : 'listdata']"
      @click="handList(item, item.id)"
      >
      <p >{{ item.name?item.name:item.content }}</p>
      <div class="dropdown" v-if="item.id == active">
        <el-dropdown >
          <span class="el-icon-more-outline"> </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              icon="el-icon-edit-outline"
              @click.native="handEdit(item, item.id)"
              >编辑</el-dropdown-item
            >
            <el-dropdown-item
              icon="el-icon-delete"
              @click.native="handDeta(item.id)"
              >删除</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </li>
  </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    ItemData: {
      type: Array,
      default: [],
    },
    active: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      actived: null,
      index:null
    };
  },
  // created() {
  //    this.actived = localStorage.getItem("id")
  //   setTimeout(() => {
  //     this.actived = this.active;
  //     this.index = this.active
     
  //     console.log(localStorage.getItem("id"))
  //   }, 1000);
  // },
  watch: {},
  computed: {},
  methods: {
    handList(item, id) {
    
      this.$emit("handList", { item: item, id: id });
  
    },
    handEdit(item ) {
     
      this.$emit("handEdit", item);
    },
    handDeta(id) {
     
      this.$emit("handDeta", id );
    },
  },
};
</script>
<style lang="less" scoped>
.conmter {
  .scroll{
      overflow-y:auto;
      height: calc(100vh - 260px);
     }
  .fontSize {
    width: 90%;
    margin: 10px 0;
    display: flex;
    padding: 0 10px;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    color: #000;
    border-radius: 4px;
  }
  .listdata {
    background-color: rgba(34, 73, 192, 0.06);
  }
  .listclick {
    background-color: #409eff;
  }
 
}
</style>